import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';

// สีตรงกับ plotLines ใน RRIStationChart.js
export const DISCHARGE_LEVELS = [
  { key: 'critical', label: 'วิกฤต',     color: '#C83C35' },
  { key: 'warning',  label: 'เตือนภัย',  color: '#ED9B4D' },
  { key: 'alarm',    label: 'เฝ้าระวัง', color: '#DFC328' },
  { key: 'normal',   label: 'ปกติ',      color: '#31985F' },
  { key: 'no_data',  label: 'ไม่มีข้อมูล', color: '#9e9e9e' },
];

const useStyles = makeStyles({
  legendContainer: {
    zIndex: 99999,
    marginTop: 10,
  },
  legend: {
    height: '20px',
    width: '20px',
    marginRight: 10,
    borderRadius: '50%',
    border: '1px solid rgba(0,0,0,0.25)',
    boxSizing: 'border-box',
  },
});

export default function DischargeLegend({
  levels = DISCHARGE_LEVELS,
  title = 'เกณฑ์ระดับเตือนภัย',
}) {
  const classes = useStyles();

  return (
    <div className={classes.legendContainer} style={{ fontFamily: "Kanit", }}>
      <Paper
        style={{
          opacity: '0.8',
          backgroundColor: '#EAEAEA',
        }}
      >
        <Box p={1}>
          <Typography variant="subtitle2" style={{ fontWeight: 700, marginBottom: 4, fontFamily: "Kanit", }}>
            {title}
          </Typography>

          {levels.map(({ key, label, color }) => (
            <Grid container alignItems="center" key={key}>
              <Grid item>
                <div style={{ backgroundColor: color }} className={classes.legend} />
              </Grid>
              <Grid item>
                <Typography variant="subtitle2" style={{ fontFamily: "Kanit", fontWeight: 400, }}>
                  {label}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Box>
      </Paper>
    </div>
  );
}